import React from "react";
import { brandlogo } from "../../assets";
import styles from "./eventhero.module.scss";
import SearchComponent from "./SearchComponent";
import { Header } from "../index";
import EventHeroImage from "./eventheroImage";

const EventHero = ({ search, setSearch }) => {
  return (
    <>
      <Header
        brand={brandlogo}
        mobileBrand={brandlogo}
        brandToggle={brandlogo}
      />
      <div className={styles.hero}>
        <div className={styles.herowrapper}>
          <div className={styles.herocontent}>
            <div className={styles.kewedleft}>
              <div className={styles.herolefttop}>
                <div className={styles.heroheading}>
                  <span className={styles.dash}></span>
                  <span className={styles.heroheadingtext}>
                    Empowering connections, fostering community
                  </span>
                </div>
                <span className={styles.herolefttexts}>
                  <p className={styles.heromanagetxt}>
                    Host delightful events and manage access
                  </p>
                  <p className={styles.eventtxt}>
                    With our user-friendly platform, you can easily create and
                    manage your event from start to finish. From setting up
                    ticket sales to managing attendees and sending out event
                    updates, our app streamlines the entire process, leaving you
                    free to focus on the details that matter.
                  </p>
                </span>
              </div>
              <div className={styles.waitlist}>
                <div className={styles.waitlistform}>
                  <SearchComponent search={search} setSearch={setSearch} />
                </div>
              </div>
            </div>
            <div className={styles.skewedright}>
              <EventHeroImage />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventHero;
